module.exports = __webpack_public_path__ + "094176f40e54914c06d1bcd920fc5036.fbx";